import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// actions
import { deleteVenue, getVenues } from "store/actions";
import { MetaTags } from "react-meta-tags";
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Container,
  Table,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Link, withRouter } from "react-router-dom";
import { map } from "lodash";
import DeleteModal from "components/Common/DeleteModal";

class VenuesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      venue: null,
      deleteModal: false,
    };
  }
  componentDidMount() {
    const { onGetVenues } = this.props;
    onGetVenues();
  }

  onClickDelete = venue => {
    this.setState({ venue, deleteModal: true });
  };

  onClickEdit = venue => {
    if (venue.id !== undefined) {
      this.props.history.push(`/venue-create/${venue.id}`);
    }
  };

  handleDeleteVenue = () => {
    const { onDeleteVenue } = this.props;
    const { venue } = this.state;
    if (venue.id !== undefined) {
      onDeleteVenue(venue.id);
      this.setState({ deleteModal: false });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ ...this.state, venues: this.props.venues });
    }
  }

  render() {
    const { venues } = this.props;
    const { deleteModal } = this.state;

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteVenue}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <MetaTags>
            <title>Starter Page | AD&amp;VISION - Event Tool</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Venues" breadcrumbItem="List" />
            <Card>
              <CardHeader className="h5 bg-transparent border-bottom text-end">
                <Button
                  color="success"
                  onClick={() => this.props.history.push("/venue-create")}
                >
                  Create New
                </Button>
              </CardHeader>
              <CardBody>
                <Table striped>
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: "100px" }}>
                        #
                      </th>
                      <th scope="col">Venue</th>
                      <th scope="col">Contacts</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {map(venues, (venue, index) => (
                      <tr key={index}>
                        <td>{venue.id}</td>
                        <td>
                          <h5 className="text-truncate font-size-14">
                            <Link
                              to={`/venues-overview/${venue.id}`}
                              className="text-dark"
                            >
                              {venue.name}
                            </Link>
                          </h5>
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            {venue.staff?.map(s => (
                              <li key={s.id} className="border-bottom mb-2">
                                {s.name}{" "}
                                {s.email && (
                                  <>
                                    <br />
                                    <a href={`mailto:${s.email}`}>{s.email}</a>
                                  </>
                                )}
                                {s.phone && (
                                  <>
                                    <br />
                                    {s.phone}
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        </td>
                        <td>
                          <ButtonGroup>
                            <Button
                              outline
                              color="success"
                              onClick={() => this.onClickEdit(venue)}
                            >
                              <i className="mdi mdi-pencil font-size-16 me-1" />{" "}
                            </Button>
                            <Button
                              outline
                              color="danger"
                              onClick={() => this.onClickDelete(venue)}
                            >
                              <i className="mdi mdi-trash-can font-size-16 me-1" />{" "}
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

VenuesList.propTypes = {
  history: PropTypes.any,
  venues: PropTypes.any,
  onGetVenues: PropTypes.func,
  onDeleteVenue: PropTypes.func,
};

const mapStateToProps = ({ Venues }) => ({
  venues: Venues.venues,
});

const mapDispatchToProps = dispatch => ({
  onGetVenues: () => dispatch(getVenues()),
  onDeleteVenue: id => dispatch(deleteVenue(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(VenuesList));
